import useScrollHandler from "@hooks/useScrollHandler"
import React from "react"

type Args = {
  formattedProducts: any[]
  productListRef: React.RefObject<HTMLDivElement>
}

/**
 * Handles infinite scroll pagination for collection pages
 */
export function useCollectionPagination({
  formattedProducts,
  productListRef,
}: Args) {
  const [renderedProductCount, setRenderedProductCount] = React.useState(18)

  const onScrollHandler = React.useCallback(() => {
    if (
      typeof window === "undefined" ||
      !productListRef ||
      !productListRef.current ||
      formattedProducts.length <= renderedProductCount
    ) {
      return
    }

    const productListNodes = productListRef.current.childNodes
    const positionReference: any = productListNodes[productListNodes.length - 3]

    if (
      positionReference &&
      positionReference.getBoundingClientRect().top < window.innerHeight
    ) {
      setRenderedProductCount(renderedProductCount + 18)
    }
  }, [productListRef, formattedProducts.length, renderedProductCount])

  useScrollHandler({
    onScroll: onScrollHandler,
    runForProps: [renderedProductCount],
  })

  return { renderedProductCount }
}
